@import "../../../../themes/site/default/assets/common_helpers_non_liquid.scss";

.following {
  margin-bottom: var(--section-spacing-small);
  position: relative;

  &--inline {
    margin-bottom: 0;
  }

  .following__state {
    text-align: left;
    @extend %alternate-link;

    > svg:last-child {
      margin-left: .5rem;
      height: 1rem;
    }

    &--wide {
      display: block;
      position: relative;
      padding-right: 1rem;

      > svg:last-child {
        position: absolute;
        right: 0;
        top: .25rem;
        margin-left: 0;
      }
    }
  }

  .following__state__icon {
    display: none;

    svg {
      height: .875em;
      margin-right: .5rem;
      margin-top: -0.2rem;
    }

    &--muted {
      display: inline-block;
    }
  }

  &--following {
    .following__state__icon {
      &--muted {
        display: none;
      }

      &--following {
        display: inline-block;
      }
    }
  }

  .following__options {
    font-size: 1rem;
    position: absolute;
    left: 0;
    right: 0;
    top: 120%;
    border: 1px solid var(--color-border);
    z-index: 1000;
    display: none;
  }

  .following__option {
    background: var(--color-body);
    padding: .5rem 1rem;
    display: block;

    svg {
      height: .875rem;
      margin-right: .5rem;
      margin-top: -0.2rem;
    }

    .following__option__label {
      color: var(--color-text);
    }

    .following__option__explanation {
      font-size: .875rem;
      color: var(--color-text-alternate);
    }

    &:hover {
      background: var(--color-primary);

      .following__option__label {
        color: #fff;
      }

      .following__option__explanation {
        color: #fff;
        opacity: 0.8;
      }
    }
  }

  &--showing-options {
    .following__state {
      > svg:last-child {
        @include transform(rotate(180deg));
      }
    }

    .following__options {
      display: block;
    }
  }

  &--float-right {
    float: right;
    margin-bottom: 1rem;
    margin-left: 1rem;

    .following__options {
      left: auto;
      width: 200px;
    }
  }
}

/* Match section style (default/alternate) - for ex on blog index template */
.simplero-section .section--alternate .following {
  .following__option:not(:hover) {
    background: var(--color-body-alternate);

    .following__option__label {
      color: var(--color-text-alternate);
    }

    .following__option__explanation {
      color: var(--color-text);
    }
  }
}
